/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getNonconformanceHoldTags,
    getNonconformanceHoldTag,
    printNonconformanceHoldTag,
    createNonconformanceHoldTags,
    updateNonconformanceHoldTags,
    deleteNonconformanceHoldTags,
} from "Modules/manufacturing/nonconformance_hold_tags/config/api.nonconformance_hold_tags";

const state = {
    page: {},
    form: {},
    nonconformance_hold_tags: [],
    nonconformance_hold_tag_options: [],
    selectedNonconformanceHoldTag: {
        hold_tag_id: null,
        company_id: "",
        nonconformance_hold_tag_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        nonconformance_hold_tag_details: [],
    },
    nonconformance_hold_tags_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_nonconformance_hold_tags: {
        hold_tag_id: {
            name: "hold_tag_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        nonconformance_id: {
            name: "nonconformance_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        reason: {
            name: "reason",
            rules: "trim|required",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        verified_by: {
            name: "verified_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        verified_date: {
            name: "verified_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        nine_point_submission: {
            name: "nine_point_submission",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        nine_point_submission_by: {
            name: "nine_point_submission_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        nine_point_submission_date: {
            name: "nine_point_submission_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        strip_chart: {
            name: "strip_chart",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        strip_chart_by: {
            name: "strip_chart_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        strip_chart_date: {
            name: "strip_chart_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        recipe_sheet: {
            name: "recipe_sheet",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        recipe_sheet_by: {
            name: "recipe_sheet_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        recipe_sheet_date: {
            name: "recipe_sheet_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        process_sheet: {
            name: "process_sheet",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        process_sheet_by: {
            name: "process_sheet_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        process_sheet_date: {
            name: "process_sheet_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        customer_contacted_by: {
            name: "customer_contacted_by",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        customer_contacted_date: {
            name: "customer_contacted_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    nonconformance_hold_tags: (state) => {
        return state.nonconformance_hold_tags;
    },
};

// actions
const actions = {
    async fetchNonconformanceHoldTags({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getNonconformanceHoldTags({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "nonconformance_hold_tag_options",
                        with: response.data.nonconformance_hold_tags,
                    });
                } else {
                    commit("mutate", {
                        property: "nonconformance_hold_tags",
                        with: response.data.nonconformance_hold_tags,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchNonconformanceHoldTag({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getNonconformanceHoldTag(payload.id);
            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedNonconformanceHoldTag",
                    with: response.data.nonconformance_hold_tag,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printNonconformanceHoldTag({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printNonconformanceHoldTag(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveNonconformanceHoldTag({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["hold_tag_id"] === "undefined" || body["hold_tag_id"] == null || body["hold_tag_id"] == "") {
                delete body["hold_tag_id"];
                response = await createNonconformanceHoldTags({ body: body, headers: config.headers });
            } else {
                let hold_tag_id = body["hold_tag_id"];
                delete body["hold_tag_id"];
                response = await updateNonconformanceHoldTags({ body: body, headers: config.headers }, hold_tag_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteNonconformanceHoldTag({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteNonconformanceHoldTags(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
